import { ShortCode } from '@highereducation/wordpress';
import { Timeline, type TimelineProps } from '@highereducation/hen-ui';
import { isTimelineMarkerColor } from '../utils';

type TimelineShortcodeProps = {
  children?: TimelineProps['children'];
  className?: string;
  color?: string;
  [key: string]: unknown;
};

export const TimelineShortcode: ShortCode<TimelineShortcodeProps> = {
  component: ({ children, className, color }) => {
    return (
      <Timeline
        className={className}
        color={isTimelineMarkerColor(color) ? color : undefined}
      >
        {children}
      </Timeline>
    );
  },
};
